import http from "@/helper/http";
import {useMutation, useQuery} from "@tanstack/react-query";
import {BaseVO} from "@/model/global";
import {DeptPO, RolePO} from "@/model/system";

export enum AccountEnum {
    Signin = "/signin?channel=1",
    Captcha = "/captcha",
    Account = "/user/getAccount",
}

export interface SigninBO {
    account: string;
    password: string;
    captcha: string;
    captchaId: string;
}

export interface SigninUserVO {
    id: number;
    username: string;
    deptId: number;
    account: string;
    avatar: string
    roleId: string;
    role: RolePO;
    dept: DeptPO;
}

export interface SigninVO {
    user: SigninUserVO;
    token: string;
}

export interface CaptchaVO {
    picPath: string;
    captchaId: string;
}

export const useCallSignin = () => useMutation<BaseVO<SigninVO>, null, SigninBO>({
    mutationFn: (data: SigninBO) =>
        http.post<BaseVO<SigninVO>>({url: AccountEnum.Signin, data})
})

export const useQueryCaptcha = () => useQuery<BaseVO<CaptchaVO>>({queryKey: ["captcha"], queryFn: () => http.get<BaseVO<CaptchaVO>>({url: AccountEnum.Captcha})});

export const useQueryAccount = () => useQuery({queryKey: ['account'], queryFn: () => http.get({url: AccountEnum.Account})});

